import React, { useContext } from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import Table from '../../../dpe-usco/components/Table/Table'
import { GlobalContext, LanguageContext } from '../../../services/context'

const LegalTemplatesTableWidget = ({ data, status, company_id }) => {

  const { dispatch } = useContext(GlobalContext)
  const langData =  useContext(LanguageContext)

  const headerContent = value => {
    return (
      <div key={value} className='cell df aic'>
        <span className='cell'>{value}</span>
      </div>
    )
  }

  const goToMasterAgreement = (e, templateInfo) => {
    e.preventDefault()
    const { contract_template_id, template_name } = templateInfo
    const detailView = {
      title: template_name,
      previous: 'Back'
    }
    dispatch({ type: 'GO_TO_MASTER_AGREEMENT', payload: { contract_template_id, detailView, company_id } })
  }

  const convertDateFromISO = date => {
    if (typeof date === 'string') {
      let returnDate = date && date.split('T')[0].split('-').reverse()
      returnDate = returnDate[1]+'/'+returnDate[0]+'/'+returnDate[2]
      return returnDate
    }
  }


  const templateStructure = {
    headers: [
      {
        value: 'File name', 
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: 'Template language', 
        format() {
          return headerContent(this.value)
        }
      },
      {
        value: 'Date uploaded', 
        format() {
          return headerContent(this.value)
        }
      }
    ],
    dataKeys: [
      'template_name',
      'template_language',
      'modified'
    ],
    rowFormat: {
      template_name: {
        allContent: true,
        format: templateInfo => {
          return(
            <a
              className='tdu c-blue-700 ml10 curp'
              href={`/master-agreement/${templateInfo.contract_template_id}`}
              onClick={e => goToMasterAgreement(e, templateInfo)}
            >
              {templateInfo.template_name}
            </a>
          )}
      },
      template_language: {
        allContent: true,
        format: templateInfo => {
          return(
            langData[langData?.findIndex(x=>x.lang_value === templateInfo.template_language)]?.lang_name 
          )}
      },
      modified: {
        format: obj => {
          return (
            <div>{convertDateFromISO(obj)}</div>
          )
        }
      }
    }
  }

  return (
    <Widget title='Legal templates'>
      <Table structure={templateStructure} data={data} status={status}/>
    </Widget>
  )
}

export default LegalTemplatesTableWidget